import { defineAction } from '~/prix'
import { z } from 'zod'
import materialInventoryDeleteAction from './materialInventoryDelete.action.json' with { type: 'json' }
import { materialInventoryObject } from '../materialInventoryObject'

const materialInventoryDeleteDefinition = defineAction({
  ...materialInventoryDeleteAction,

  input: materialInventoryObject.pick({
    id: true,
  }),
  output: z.object({}),
})

export default materialInventoryDeleteDefinition
